import { roundToNearestDollar } from "common/numbers";

export const convertToRPM = ({ price, layer }) => {
  if (
    price == null ||
    layer == null ||
    layer.limit == null ||
    layer.limit === 0
  ) {
    return null;
  }
  return (1_000_000 * price) / layer.limit;
};

export const convertFromRPM = ({ rpm, layer }) => {
  if (
    rpm == null ||
    layer == null ||
    layer.limit == null ||
    layer.limit === 0
  ) {
    return null;
  }
  return (layer.limit * rpm) / 1_000_000;
};

export const extractLayerPrice = ({ layer, measure, model = null }) => {
  model = model ?? layer?.pricing?.selectedModel;
  return layer?.pricing?.prices?.[model]?.[measure] ?? null;
};

export const extractLayerSelectedPrice = ({ layer, model = null }) => {
  model = model ?? layer?.pricing?.selectedModel;
  return (
    layer?.pricing?.selectedPrices?.[model] ??
    extractLayerPrice({
      layer,
      model,
      measure: layer?.pricing?.selectedMeasures?.[model],
    })
  );
};

// With roundPricing (the pricing/roundPricingToWholeDollar flag) the net
// premium amounts are whole dollars like the gross amounts the layer resolver
// rounds; the ratios and technical prices keep full precision.
export const calculatePricePerspectives = ({
  price,
  layer,
  roundPricing = false,
}) => {
  const purePremium = price;
  const technicalFactor = (100 - layer.tac) / 100;
  const netPremium = (layer.grossPremium * (100 - layer.tac)) / 100;
  const shareOfNetPremium = (netPremium * layer.shareOfLine) / 100;
  const money = roundPricing ? roundToNearestDollar : (value) => value;

  let perspectives = {
    netPremium: money(netPremium),
    shareOfNetPremium: money(shareOfNetPremium),
  };

  if (purePremium != null) {
    const profitFactor = (100 - layer.profit - layer.expenses) / 100;
    const technicalRatio = purePremium / (layer.grossPremium * technicalFactor);

    perspectives = {
      ...perspectives,
      purePremium,
      requiredPremium: purePremium / technicalFactor / profitFactor,
      lossRatio: (purePremium / layer.grossPremium) * 100,
      technicalRatio: technicalRatio * 100,
      targetPrice: (profitFactor / technicalRatio) * 100,
    };
  }

  const removeNans = (obj) =>
    Object.fromEntries(
      Object.entries(obj).filter(([_, value]) => !isNaN(value))
    );

  return removeNans(perspectives);
};
